import { render } from "./TabelaReqPorProjeto.vue?vue&type=template&id=ed7effae&scoped=true"
import script from "./TabelaReqPorProjeto.vue?vue&type=script&scoped=true&lang=js"
export * from "./TabelaReqPorProjeto.vue?vue&type=script&scoped=true&lang=js"

import "./TabelaReqPorProjeto.vue?vue&type=style&index=0&id=ed7effae&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed7effae"]])

export default __exports__